<template>
        <div class="overflow-hidden" v-if="article">
            <a :href="goToBlog" :title="article.title">
                <img class="rounded-8 object-cover main-blog-img w-full h-225px lg:h-244px lazyload"
                     :class="imgHeight"
                     :data-src="article.article_tile_image" :alt="article.title">
            </a>

            <div class="mt-l text-onyx">
                <a :title="article.title" :href="goToBlog" class="font-bold text-21 text-onyx hover:underline cursor-pointer">{{ article.title }}</a>

                <p class="mt-s leading-1-69 text-sm">
                    {{ article.excerpt }}
                </p>

                <p class="mt-m md:mt-23px text-12 leading-normal font-semibold">
                    <span class="text-onyx">
                        {{ article.published_at }} .
                    </span>
                    <span v-for="(tag, slug, index) in article.tags" :key="tag.id">
                        <span class="hover:underline cursor-pointer">
                            <a :title="tag" :href="goToCategory(slug)" class="text-onyx-lightest">{{ tag | capitalize }}</a>
                        </span>{{ index !== Object.keys(article.tags).length - 1 ? ', ' : '' }}
                    </span>
                </p>
            </div>
        </div>
</template>

<script>
    import CCRequestInputMixin from "../../mixins/CCRequestInputMixin";
    export default {
        name: "BlogHeader",
        mixins: [CCRequestInputMixin],
        props: {
            article: {
                type: Object,
                required: true
            },
            urlBlogShow: {
                type: String,
                required: true
            },
            urlBlogCategory: {
                type: String,
                required: true
            },
            imgHeight: {
                type: String,
                required: true
            },
        },

        computed: {
            goToBlog() {
                return this.addCCToRoute(this.urlBlogShow + '/' + this.article.slug);
            },
        },

        methods: {
            goToCategory(slug) {
                return this.addCCToRoute(this.urlBlogCategory + '/' + slug);
            }
        }
    }
</script>

<style scoped>

</style>
